import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { SdsApiService } from '../services/sds-api.service';

@Component({
  selector: 'sds-public-preview',
  templateUrl: 'sds-public-preview.component.html',
  styleUrls: ['sds-public-preview.component.css'],
  standalone: false
})
export class SdsPublicPreviewComponent implements OnInit {
  pdfPreviewVisible = false;
  pdfPreviewUrl: SafeResourceUrl | null = null;
  downloadUrl = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private sdsApiService: SdsApiService
  ) {}

  ngOnInit(): void {
    const token = (this.route.snapshot.paramMap.get('token') || '').trim();
    if (!token) {
      return;
    }

    const previewFileUrl = this.sdsApiService.getPublicShareFileUrl(token);
    this.downloadUrl = this.sdsApiService.getPublicShareFileUrl(token, true);
    this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${previewFileUrl}#view=Fit`);
    this.pdfPreviewVisible = true;
  }

  openPdfPreview(): void {
    this.pdfPreviewVisible = true;
  }

  closePdfPreview(): void {
    this.pdfPreviewVisible = false;
  }

  downloadPdf(): void {
    if (this.downloadUrl.length === 0) {
      return;
    }

    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.target = '_blank';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
